<template>
    <div class="pieEcharts">
        <div :id="echarts" :style="{width: '510px', 'height': height}"></div>
    </div>
</template>

<script>
    var echarts = require('echarts');
    export default {
        name: "pieEcharts",
        props: {
            height: {
                type: String,
                default: '420px'
            },
            pieData:{
                type:Object,
                default() {
                    return { seriesName:'',pieEchartsData:[] }
                }
            }
        },
        methods:{
            pieEchartsInit(){
                // 左、下、右、上
                // let color1 = new echarts.graphic.LinearGradient(1, 0, 0, 0,[{ offset: 0, color: "#6648FF" }, { offset: 1, color: "#16CEB9" }],false);
                // let color2 = new echarts.graphic.LinearGradient(1, 1, 0, 1,[{ offset: 0, color: "#6648FF" }, { offset: 1, color: "#16CEB9" }],false);
    //             let color6 = new echarts.graphic.LinearGradient(1, 1, 1, 0,[{ offset: 0, color: "#1CC4BE" },{ offset: 0.2, color: "#1CC4BE " }, { offset: 1, color: "#3772D1" }],false);
    //             let color5 = new echarts.graphic.LinearGradient(1, 0, 1, 1,[{ offset: 0, color: "EAADEA" },{ offset: 0.2, color: "#EAADEA" }, { offset: 1, color: "#3772D1" }],false);
    //             let color7 = new echarts.graphic.LinearGradient(1, 1, 1, 0,[{ offset: 0, color: "#FF7F00 " },{ offset: 0.2, color: "#FF7F00 " }, { offset: 1, color: "#3772D1" }],false);
				 let color4 = new echarts.graphic.LinearGradient(1, 1, 1, 0,[{ offset: 0, color: "#8C7853 " },{ offset: 0.2, color: "#8C7853 " }, { offset: 1, color: "#3772D1" }],false);
				//let color3 = new echarts.graphic.LinearGradient(1, 1, 1, 0,[{ offset: 0, color: "#6B238E " },{ offset: 0.2, color: "#6B238E" }, { offset: 1, color: "#3772D1" }],false);
				let color2 = new echarts.graphic.LinearGradient(1, 1, 1, 0,[{ offset: 0, color: "#00FF00 " },{ offset: 0.2, color: "#00FF00 " }, { offset: 1, color: "#3772D1" }],false);
				let color1 = new echarts.graphic.LinearGradient(1, 1, 1, 0,[{ offset: 0, color: "#ff9900" },{ offset: 0.2, color: "#ff9900" }, { offset: 1, color: "#3772D1" }],false);
                let myChart = echarts.init(document.getElementById(this.echarts));
                let option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    color: [color1, color2,  color4],
                    series: [
                        {
                            name: this.pieData.seriesName,
                            type: 'pie',
                            radius: '130px',
                            center: ['50%', '45%'],
                            roseType: 'radius',
                            itemStyle: {
                                normal : {
                                    label : {
                                        show : true,
                                        alignTo: 'edge',
                                        formatter: '{name|{b}}\n{value|{c} %}',
                                        minMargin: 0,
                                        edgeDistance: -55,
                                        padding: [0, 70],
                                        lineHeight: 25,
                                        rich: {
                                            name:{
                                                fontSize: 16,
                                                color: '#fff',
                                            },
                                            value: {
                                                fontSize: 16,
                                                color: '#00DDFF'
                                            }
                                        }
                                    },
                                    labelLine : {
                                        show : true,
                                        length: 20,
                                    },
                                    shadowBlur: 24,
                                    shadowColor: 'rgba(32, 0, 176, 0.5)',
									color: function (colors) {
									         var colorList = [
									           '#fc8251',
									           '#5470c6',
									           '#91cd77',
									           '#ef6567',
									           '#f9c956',
											    '#1CC4BE',
												 '#6648FF',
												  '#00FF00',
									           '#75bedc'
									         ];
									         return colorList[colors.dataIndex];
									       }
                                }
                            },
                            data:this.pieData.pieEchartsData,
                            animationType: 'scale',
                            animationEasing: 'elasticOut',
                            animationDelay: function (idx) {
                                return Math.random() * 200;
                            }
                        }
                    ]
                }
                myChart.setOption(option);
            }
        },
        watch: {
            pieData: {
                deep: true,
                handler: () => this.pieData
            },
			
			//this.pieEchartsInit()
        },
        mounted() {
            this.pieEchartsInit()
            window.addEventListener("resize", this.pieEchartsInit);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.pieEchartsInit);

        },
        computed: {
            echarts() {
                return 'echarts' + Math.random() * 100000;
            }
        },
    }
</script>

<style scoped>

</style>